import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

/* слайдер product */
let productSlider = new Swiper(".object-content__product-slider .swiper-container", {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    navigation: {
        nextEl: ".object-content__product-slider-next",
        prevEl: ".object-content__product-slider-prev",
    },
    pagination: {
        el: ".object-content__product-slider-pagination",
        clickable: true,
    },
    breakpoints: {
        300: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        1170: {
            slidesPerView: 3,
        }
    },

});
/* слайдер product */
/* слайдер images */
let imagesSlider = new Swiper(".object-content__imageslider .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
        nextEl: ".object-content__imageslider-next",
        prevEl: ".object-content__imageslider-prev",
    },
});
/* слайдер images */